import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'analytics/trackFunctions'
import PageWrapper from 'components/PageWrapper'
import TextInputField from 'components/input'
import PrimaryButton from 'components/primaryButton'
import { getCashoutDestination } from 'api/cashout'
import { useSelectedAccountStore } from 'store'
import { getEntity } from 'api/bank'

const NewAccount = () => {
  const [inputValue, setInputValue] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { updateSelectedAccount, updateEntityData } = useSelectedAccountStore()

  const navigate = useNavigate()

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_ingresar_dato' })
  }, [])

  const onClick = () => {
    if (isLoading) return

    let type: 'CBU' | 'ALIAS'

    if (inputValue.length === 22 && /^\d+$/.test(inputValue)) {
      type = 'CBU'
    } else {
      type = 'ALIAS'
    }

    setIsLoading(true)

    getCashoutDestination({ type, value: inputValue })
      .then((res) => {
        if (res.success) {
          const { result: data } = res.data
          updateSelectedAccount({
            CVU: data.cvu,
            CBU: data.cbu,
            CUIL: Number(data.tax_identification_value),
            accountHolder: data.account_holder,
            comesFromNewAccount: true
          })

          const entityCode = data.bank_code
          getEntity(entityCode).then((res) => {
            const { data } = res
            updateEntityData({
              bankName: data.description || data.entity_name,
              iconURL: data.bank_image,
              bankCode: entityCode
            })

            navigate('/transferencias/destinatario')
          })
        } else {
          navigate('/transferencias/error-nueva-cuenta')
        }
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <PageWrapper
      noTabBar
      title='Transferir a nueva cuenta'
      viewSelected='/movimientos'
    >
      <section className='h-[calc(100vh-12rem)] text-black mx-auto justify-center sm:max-w-[22.5rem]'>
        <div className='h-full'>
          <h2 className='text-xs font-medium text-left self-start'>
            Ingresá el CBU / CVU o ALIAS de la cuenta a transferir
          </h2>
          <TextInputField
            autoComplete='off'
            inputType='text'
            label='CBU/CVU o ALIAS'
            id='account'
            maxLength={22}
            value={inputValue}
            callbackFunction={(e) => setInputValue(e.target.value)}
          />
        </div>
        <PrimaryButton
          isLoading={isLoading}
          buttonText='Continuar'
          className='mt-auto'
          primaryButtonFunction={() => onClick()}
          isDisabled={inputValue.length < 6 || inputValue.length > 22}
        />
      </section>
    </PageWrapper>
  )
}

export default NewAccount
